import { AlertCircle } from 'lucide-react';
import ModalBackdrop from './ModalBackdrop';

function SaveConfirmationModal({
  isOpen,
  isConfirming,
  title = 'Confirm save',
  message = 'Please review your inputs before saving this record.',
  confirmLabel = 'Save',
  confirmingLabel = 'Saving...',
  cancelLabel = 'Review',
  onCancel,
  onConfirm,
}) {
  if (!isOpen) {
    return null;
  }

  return (
    <ModalBackdrop
      backdropClassName="bg-[rgba(33,27,22,0.18)]"
      contentClassName="items-center"
      zIndexClassName="z-[90]"
    >
      <div className="w-full max-w-md rounded-[22px] border border-[var(--theme-border-soft)] bg-white p-6 shadow-[0_24px_60px_rgba(var(--theme-shadow-rgb),0.18)]">
        <div className="flex items-start gap-3">
          <span className="grid h-10 w-10 shrink-0 place-items-center rounded-[14px] bg-[var(--theme-surface-soft)] text-[var(--theme-accent)]">
            <AlertCircle className="h-5 w-5" aria-hidden="true" />
          </span>
          <div>
            <h3 className="m-0 text-[1.12rem] font-semibold tracking-[-0.03em] text-[var(--theme-text)]">
              {title}
            </h3>
            <p className="m-0 mt-2 text-[0.94rem] leading-6 text-[var(--theme-text-muted)]">
              {message}
            </p>
          </div>
        </div>

        <div className="mt-6 grid gap-3 sm:grid-cols-2">
          <button
            className="inline-flex min-h-[44px] items-center justify-center rounded-[14px] border border-[var(--theme-border)] bg-white px-5 text-[0.92rem] font-semibold text-[var(--theme-text-subtle)] shadow-[0_6px_14px_rgba(var(--theme-shadow-rgb),0.05)] outline-none transition hover:bg-[var(--theme-surface-soft)] focus-visible:ring-2 focus-visible:ring-[var(--theme-focus)] focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60"
            type="button"
            onClick={onCancel}
            disabled={isConfirming}
          >
            {cancelLabel}
          </button>
          <button
            className="inline-flex min-h-[44px] items-center justify-center rounded-[14px] bg-[var(--theme-text-subtle)] px-5 text-[0.92rem] font-semibold text-white shadow-[0_10px_22px_rgba(var(--theme-shadow-rgb),0.18)] outline-none transition hover:bg-[var(--theme-accent-strong)] focus-visible:ring-2 focus-visible:ring-[var(--theme-focus)] focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:border disabled:border-[var(--theme-border)] disabled:bg-[var(--theme-accent-soft)] disabled:text-[var(--theme-accent-strong)] disabled:shadow-none"
            type="button"
            onClick={onConfirm}
            disabled={isConfirming}
          >
            {isConfirming ? confirmingLabel : confirmLabel}
          </button>
        </div>
      </div>
    </ModalBackdrop>
  );
}

export default SaveConfirmationModal;
